import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from "react-router-dom";
import { useHistory } from 'react-router';
import { unauthHeaders } from '../../utils/API';
import { ErrorAlert } from '../../utils/Alerts';
import Schedule from './Schedule';
import moment from 'moment';
import UserContext from '../../UserContext';
import dayjs from 'dayjs';

const ScheduleContainer = () => {
    const history = useHistory();

    const [isLoading, setIsLoading] = useState(false);
    const [isCalendarLoading, setIsCalendarLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState();
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-01'));
    const [endDate, setEndDate] = useState(moment().add(1, 'month').format('YYYY-MM-01'));

    const [sheduleList, setSheduleList] = useState([]);
    const [selectedDay, setSelectedDay] = useState(moment());

    const [cellsList, setCellsList] = useState([]);
    const [selectedCell, setSelectedCell] = useState();
    const [logs, setLogs] = useState([]);

    const [availableDoctor, setAvailableDoctor] = useState();
    const [appointmentInfo, setAppointmentInfo] = useState();

    const {
        setAppointment,
        payType,
        specializationName,
        setCabinetName,
        clinic,
        user,
        setIsDisabledNextBtn,
        sendingCompanyId,
    } = useContext(UserContext);

    const { clinicId, specializationId, doctor, categoryType, buildingId, cabinetId, typeServices } = useParams();
    const userId = sessionStorage.getItem('userId');

    const getScheduleList = () => {
        const formattedStartDate = encodeURIComponent(moment(startDate).format('YYYY-MM-DDTHH:mm:ssZZ'));
        const formattedEndDate = encodeURIComponent(moment(endDate).format('YYYY-MM-DDTHH:mm:ssZZ'));

        setIsCalendarLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/calendar?clinicId=${clinicId}&${typeServices !== 'researches' ? `specializationId=${[specializationId]}` : `ResearchIds=${[specializationId]}`}&buildingId=${buildingId}&userId=${userId}&startDate=${formattedStartDate}&endDate=${formattedEndDate}&categoryType=${categoryType}&Cabinet=${cabinetId === 'undefined' ? '' : cabinetId}&payType=${payType}&appointmentStatusesToShow=Scheduled&appointmentStatusesToShow=Completed&appointmentStatusesToShow=NotCompleted&appointmentStatusesToShow=Awaiting`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsCalendarLoading(false);
                setSheduleList(res.data);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsCalendarLoading(false);
            });
    }

    const getCellsList = (day) => {
        const formattedDate = moment(day).format();

        setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/timetable?clinicId=${clinicId}&buildingId=${buildingId}&userId=${userId}&date=${encodeURIComponent(moment(formattedDate).format('YYYY-MM-DD'))}&categoryType=${categoryType}&${typeServices !== 'researches' ? `specializationId=${[specializationId]}&Cabinet=${cabinetId === 'undefined' ? '' : cabinetId}` : `ResearchIds=${[specializationId]}`}&payType=${payType}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setCellsList(res.data.cells);
                setLogs(res.data.logs);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const lockCell = (cell, appointmenter, info) => {
        setAppointment({
            // Id: selectedCell.scheduleId,
            AppointmentDateTime: cell.time,
            PatientInfo: {
                Id: userId,
                Name: `${user.lastName} ${user.firstName != undefined ? user.firstName : ''} ${user.middleName != undefined ? user.middleName : ''}`,
            },
            ClinicInfo: {
                Id: clinicId,
                Name: clinic?.name,
                Address: clinic?.address
            },
            DoctorInfo: typeServices !== 'researches' ? {
                Id: appointmenter?.id,
                FirstName: appointmenter?.firstName,
                MiddleName: appointmenter?.middleName,
                LastName: appointmenter?.lastName,
                SpecializationId: appointmenter?.specializationId,
                Specialization: appointmenter?.specialization,
                CabinetName: cell?.cabinetName,
            } : { },
            Researches: typeServices !== 'researches' ? [
            ] : [{
                Id: specializationId,
                Name: specializationName
            }],
            CategoryType: categoryType,
            Price: info.price,
            PayType: payType,
            SendingCompanyId: sendingCompanyId,
            ScheduleId: cell.scheduleId,
        })

        // setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/timetable/check-and-lock-cell?scheduleId=${cell.scheduleId}&appointmentDate=${encodeURIComponent(moment(cell.time).format('YYYY-MM-DDTHH:mm:ssZZ'))}&userId=${userId}&clinicId=${clinicId}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/finish/${typeServices}`)
                // setIsDisabledNextBtn(false);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const getAppointmentInfo = (cell, appointmenter) => {
        // setIsLoading(true);
        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/appointments/info?userId=${userId}&scheduleId=${cell.scheduleId}${typeServices === 'researches' ? `&ResearchIds=${[specializationId]}` : ''}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setAppointmentInfo(res.data);
                lockCell(cell, appointmenter, res.data);
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage(err.response.data.message);
                setIsLoading(false);
            });
    }

    const getAvailableDoctor = (cell) => {
        // setIsLoading(true);
        if (!cell.doctorAvailable) {
            getAppointmentInfo(cell, {
                specialization: specializationName,
                SpecializationId: specializationId,
            });
            return
        }

        axios.get(`${process.env.REACT_APP_API}api/v1.0/schedule/available-doctor?clinicId=${clinicId}&scheduleId=${cell.scheduleId}`, {
            headers: {
                ...unauthHeaders,
                Authorization: `Bearer ${sessionStorage.getItem('token')}`,
            }
        })
            .then((res) => {
                setIsLoading(false);
                setAvailableDoctor(res.data);
                getAppointmentInfo(cell, res.data);
            })
            .catch((err) => {
                console.log(err);
                if (err.response.data.message.includes('Врач не найден')) {
                    getAppointmentInfo(cell);
                } else {
                    setErrorMessage(err.response.data.message);
                }
                setIsLoading(false);
            });
    }



    useEffect(() => {
        getScheduleList();
    }, [startDate])

    useEffect(() => {
        getCellsList(selectedDay);
    }, [selectedDay])

    useEffect(() => {
        if (!payType) {
            history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk`);
        }
    }, [])

    const handleClickAppointments = () => {
        getAvailableDoctor();
        setIsDisabledNextBtn(true);
        // history.push(`${process.env.REACT_APP_WEBSITE_NAME}/lk/finish`);
    }

    const handleClickDay = (e) => {
        setSelectedDay(e);
        setIsDisabledNextBtn(true);
        setSelectedCell(false);
    }

    const onMonthChange = (e) => {
        setStartDate(moment(e).format('YYYY-MM-DD'));
        setEndDate(moment(e).add(1, 'month').format('YYYY-MM-DD'));
    }

    const handleClickCell = (e) => {
        setSelectedCell(e);
        setCabinetName(e.cabinetName);
        setIsDisabledNextBtn(false);
        setTimeout(() => {
            getAvailableDoctor(e);
        }, 200);
    }

    return (
        <>
            {errorMessage && <ErrorAlert errorMessage={errorMessage} setErrorMessage={setErrorMessage} />}
            <Schedule
                isLoading={isLoading}
                isCalendarLoading={isCalendarLoading}
                doctor={doctor}

                sheduleList={sheduleList}
                selectedDay={selectedDay}
                handleClickDay={handleClickDay}
                onMonthChange={onMonthChange}

                cellsList={cellsList}
                selectedCell={selectedCell}
                handleClickCell={handleClickCell}

                logs={logs}

                handleClickAppointments={handleClickAppointments}

                payType={payType === 'Cash' ? "Наличный расчет" : ""}
            />
        </>
    )
}

export default ScheduleContainer;
